<template>
  <InstanceSyncModal
    :open="showInstanceSyncModal"
    :close="handleCloseInstanceSyncModal"
    :componentId="getComponentId('abi_blog')"
    :instanceName="instanceName"
    :formData="formData"
    type="blog"
  />
  <BlogDuplicateModal
    :open="showBlogDuplicateModal"
    :close="handleCloseBlogDuplicateModal"
    :formData="formData"
    :instanceName="instanceName"
  />
  <InstanceNameEditModal
    :open="showNameEditModal"
    :close="handleCloseNameEditModal"
    :componentId="getComponentId('abi_blog')"
    :instanceId="instanceId"
  />
  <ComponentPreviewModal
    :open="showComponentPreviewModal"
    :close="handleCloseComponentPreviewModal"
    :shortCode="`[abi_blog name=${getComponentId('abi_blog')}|${
      this.instanceName
    }]`"
  />
  <div
    class="rounded-t bg-white mb-0 px-6 py-6 flex justify-between uppercase font-bold items-center"
  >
    <button @click="handleGoBack" class="flex">
      <IconChevronLeft />
      <h3>{{ instanceName || "Loading..." }}</h3>
    </button>
    <div class="text-center flex justify-end items-center">
      <button
        :disabled="!validationStatus"
        :class="
          loading
            ? 'bg-gray-200 active:bg-gray-300'
            : 'bg-emerald-500 active:bg-emerald-600'
        "
        @click="handleEdit"
        class="mr-1 inline-flex items-center text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        Save
        <IconSync class="animate-spin" v-if="getInstanceEditLoading" />
      </button>
      <button
        :disabled="!validationStatus"
        @click="handleOpenInstanceSyncModal"
        :class="
          loading
            ? 'bg-gray-200 active:bg-gray-400'
            : 'bg-emerald-500 active:bg-emerald-600'
        "
        class="flex text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
      >
        <IconGlobalAlt class="w-4 h-4 m-0 mr-2" />
        Sync
      </button>
      <button
        @click="handleOpenBlogDuplicateModal"
        :disabled="loading"
        :class="
          loading
            ? 'bg-gray-200 active:bg-gray-300 cursor-not-allowed'
            : 'bg-gray-500 active:bg-gray-600'
        "
        class="mr-1 inline-flex items-center text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
      >
        Duplicate
        <IconSync class="animate-spin" v-if="getInstanceCopyLoading" />
      </button>
      <button
        @click="handleOpenNameEditModal"
        :disabled="loading"
        :class="
          loading
            ? 'bg-gray-200 active:bg-gray-300'
            : 'bg-yellow-500 active:bg-yellow-600'
        "
        class="mr-1 inline-flex items-center text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
      >
        Edit Name
      </button>
      <button
        @click="handleOpenComponentPreviewModal"
        class="mr-8 inline-flex items-center bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
        type="button"
      >
        Live View
      </button>
    </div>
  </div>
</template>

<script>
import ComponentPreviewModal from "@/components/Shared/Modal/ComponentPreviewModal";
import InstanceNameEditModal from "@/components/Shared/Modal/InstanceNameEditModal";
import BlogDuplicateModal from "@/components/Shared/Modal/BlogDuplicateModal";
import IconChevronLeft from "@/assets/icons/IconChevronLeft";
import IconGlobalAlt from "@/assets/icons/IconGlobalAlt";
import { mapGetters } from "vuex";
import InstanceSyncModal from "@/components/Shared/Modal/InstanceSyncModal";
import IconSync from "@/assets/icons/IconSync";

export default {
  name: "BlogEditPageHeader",
  components: {
    IconChevronLeft,
    IconSync,
    ComponentPreviewModal,
    InstanceNameEditModal,
    BlogDuplicateModal,
    InstanceSyncModal,
    IconGlobalAlt
  },
  data() {
    return {
      showNameEditModal: false,
      showComponentPreviewModal: false,
      showBlogDuplicateModal: false,
      showInstanceSyncModal: false
    };
  },
  props: {
    formData: {
      type: Object,
      require: true
    },
    instanceName: {
      type: String,
      required: true
    },
    handleEdit: {
      type: Function,
      required: true
    },
    validationStatus: {
      type: Boolean,
      required: true
    },
    instanceId: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleGoBack() {
      this.$router.back();
    },
    handleOpenNameEditModal() {
      this.showNameEditModal = true;
    },
    handleCloseNameEditModal() {
      this.showNameEditModal = false;
    },
    handleOpenComponentPreviewModal() {
      this.showComponentPreviewModal = true;
    },
    handleCloseComponentPreviewModal() {
      this.showComponentPreviewModal = false;
    },
    handleOpenBlogDuplicateModal() {
      this.showBlogDuplicateModal = true;
    },
    handleCloseBlogDuplicateModal() {
      this.showBlogDuplicateModal = false;
    },
    handleOpenInstanceSyncModal() {
      this.showInstanceSyncModal = true;
    },
    handleCloseInstanceSyncModal() {
      this.showInstanceSyncModal = false;
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getBlogInstancesLoading",
      "getInstanceEditLoading",
      "getInstanceCopyLoading",
      "getAllComponent",
      "getInstanceInfo"
    ])
  }
};
</script>
